import { IconChevronUpTN } from '../../icons'
import { calcRem } from '../../__styling/style-functions/calc-rem'
import styled from '@emotion/styled'

export const AccordionContainer = styled.div(({ theme }) => ({
    cursor: 'pointer',
    margin: theme.kind === 'thenightly' ? calcRem(0, 24) : 0,
}))

export const ExpanderButton = styled.div(({ theme }) => ({
    padding: calcRem(16, 0),
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 'auto',
}))

export const HeadingWrapper = styled.div({
    flex: 1,
    display: 'flex',
    alignItems: 'center',
})

export const HeadingLabel = styled.h3(({ theme }) => ({
    margin: 0,
    fontFamily: theme.fonts.sansSerif,
    fontSize: calcRem(20),
}))

export interface StyledIconContainerProps {
    selected: boolean
}

export const IconWrapper = styled.div<StyledIconContainerProps>(
    ({ selected }) => ({
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginLeft: calcRem(0),
        width: calcRem(24),
        height: calcRem(30),
        transformOrigin: 'center',
        transform: selected ? 'rotate(0deg)' : 'rotate(180deg)',
        transition: 'transform 0.25s ease-in-out',
    }),
)

export const ExpanderIcon = styled(IconChevronUpTN)({
    width: '100%',
    height: '100%',
})

export const ContentWrapper = styled.div(({ className }) => ({
    ...(className === 'electorate-sidebar-filter' && {
        display: 'flex',
        flexDirection: 'column',
        gap: calcRem(24),
    }),
}))
